import React, { Suspense } from 'react';
import { useLazyComponent } from '@trello/use-lazy-component';
import { ErrorBoundary } from 'app/src/components/ErrorBoundary';
import { PermissionsContextProvider } from 'app/src/components/BoardDashboardView/PermissionsContext';
import { SingleBoardViewProvider } from 'app/src/components/BoardViewContext/SingleBoardViewProvider';
import { SingleBoardViewFiltersProvider } from 'app/src/components/ViewFilters/SingleBoardViewFiltersProvider';
import { ChunkLoadErrorBoundary } from 'app/src/components/ChunkLoadErrorBoundary';

interface TimelineViewWrapperProps {
  idBoard: string;
  navigateToCard: (id: string) => void;
  closeView: () => void;
}

export const TimelineViewWrapper: React.FunctionComponent<TimelineViewWrapperProps> = ({
  idBoard,
  navigateToCard,
  closeView,
}: TimelineViewWrapperProps) => {
  const TimelineView = useLazyComponent(
    () => import(/* webpackChunkName: "timeline-view" */ './TimelineView'),
    { namedImport: 'TimelineView' },
  );
  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-ecosystem',
        feature: 'Timeline View',
      }}
    >
      <Suspense fallback={null}>
        <ChunkLoadErrorBoundary fallback={null}>
          <PermissionsContextProvider idBoard={idBoard}>
            <SingleBoardViewFiltersProvider idBoard={idBoard}>
              <SingleBoardViewProvider
                idBoard={idBoard}
                navigateToCard={navigateToCard}
                closeView={closeView}
                isDateBasedView={true}
              >
                <TimelineView idBoard={idBoard} />
              </SingleBoardViewProvider>
            </SingleBoardViewFiltersProvider>
          </PermissionsContextProvider>
        </ChunkLoadErrorBoundary>
      </Suspense>
    </ErrorBoundary>
  );
};
